import React, { useEffect } from 'react';
import { Container, Form, Col, Row } from 'react-bootstrap';
import { useForm } from 'react-hook-form/dist/react-hook-form.ie11';
import { customValidators } from '../Helpers/Validators/customValidators';
import PropTypes from 'prop-types';
import { object, string } from 'yup';
import { TextInput, SelectInput, RadioInput } from '../Helpers/Inputs';
import StyledRadioInput from '../Helpers/Inputs/StyledRadioInput';
import States from '../Helpers/Lists/States';
import HealthClasses from '../Helpers/Lists/HealthClasses';
import BackNextButton from '../Common/BackNextButton';
import { InputMaskDate } from '../Helpers/Formatters';
import TitleComponent from '../Common/TitleComponent';

export default function PrimaryInsuredInfo(props) {
   const isLedger =  props.fullFormState && props.fullFormState.pages.inforceLedger && props.fullFormState.pages.inforceLedger.inForceLedgerType!=='inforceLedgerNeeded' ? true:false
    const { register, errors, handleSubmit, setValue, triggerValidation } = useForm({
        validationSchema: PrimaryInsuredInfo.ValidationSchema(props.ageSpecs,props.isTerm,isLedger),
        mode: 'onBlur',
        reValidateMode: 'onBlur',
    });

    const handleValueChange = (field, value) => {
        setValue(field, value);
        props.onFieldChange(field, value);
        triggerValidation(field);
    };

    useEffect(() => {
        // manually register fields for validation that don't play nice with react-hook-form register
        register({ name: 'clientFirstName' });
        setValue('clientFirstName', props.formState.clientFirstName);

        register({ name: 'clientLastName' });
        setValue('clientLastName', props.formState.clientLastName);

        register({ name: 'gender' });
        setValue('gender', props.formState.gender);

        register({ name: 'birthdate' });
        setValue('birthdate', props.formState.birthdate);

        register({ name: 'state' });
        setValue('state', props.formState.state);

        register({ name: 'maritalStatus' });
        setValue('maritalStatus', props.formState.maritalStatus);

        register({ name: 'health' });
        setValue('health', props.formState.health);

        register({ name: 'email' });
        setValue('email', props.formState.email);

        register({ name: 'secondaryInsuredName' });
        setValue('secondaryInsuredName', props.formState.secondaryInsuredName);

    }, [register]);

    return (
        <Container fluid className='border-class'>
            <form onSubmit={handleSubmit(props.onNext)}>
                <Row className="justify-content-center pt-4">
                    <Col lg={4} className="pt-3">
                    <TitleComponent title="Primary Insured Info" />
                        <Form.Group>
                            <TextInput
                                name="clientFirstName"
                                id="clientFirstName"
                                label="Client’s First Name"
                                value={props.formState.clientFirstName}
                                onChange={e => handleValueChange('clientFirstName', e.target.value)}
                                errors={errors && errors.clientFirstName}
                                inputRef={register}
                            />
                        </Form.Group>

                        <Form.Group>
                            <TextInput
                                name="clientLastName"
                                id="clientLastName"
                                label="Client's Last Name"
                                value={props.formState.clientLastName}
                                onChange={e => handleValueChange('clientLastName', e.target.value)}
                                errors={errors && errors.clientLastName}
                                inputRef={register}
                            />
                        </Form.Group>

                        <Form.Group>
                            <TextInput
                                name="birthdate"
                                id="birthdate"
                                label="Date of Birth"
                                value={props.formState.birthdate}
                                onChange={(e) => handleValueChange('birthdate', e.target.value)}
                                inputRef={register}
                                InputProps={{
                                    inputComponent: InputMaskDate,
                                }}
                                errors={errors && errors.birthdate}
                            />
                        </Form.Group>

                       {(props.isTerm || isLedger) && <div>
                        <Form.Group>
                            <SelectInput
                                name="state"
                                id="state"
                                value={props.formState.state}
                                onChange={(e) => handleValueChange('state', e.target.value)}
                                label="State"
                                selectOptions={States()}
                                errors={errors.state}
                                inputRef={register}
                                hideEmptyOption
                            />
                        </Form.Group>

                        <Form.Group>
                            <StyledRadioInput
                                name="gender"
                                id="gender"
                                value={props.formState.gender}
                                options={[
                                    { value: 'F', label: 'Female' },
                                    { value: 'M', label: 'Male' },
                                ]}
                                onChange={(e) => handleValueChange('gender', e)}
                                errors={errors.gender}
                             />
                        </Form.Group>

                        <Form.Group>
                            <RadioInput
                                name="maritalStatus"
                                id="maritalStatus"
                                label="Marital Status"
                                value={props.formState.maritalStatus}
                                radios={[{ value: "Single", label: "Single" }, { value: "Married", label: "Married" }]}
                                onChange={e => handleValueChange('maritalStatus', e.target.value)}
                                errors={errors.maritalStatus}
                                inputRef={register}
                            />
                        </Form.Group>

                        <Form.Group>
                            <TextInput
                                name="email"
                                id="email"
                                label="Email"
                                value={props.formState.email}
                                errors={errors && errors.email}
                                inputRef={register}
                                onChange={(e) => handleValueChange('email', e.target.value)}
                            />
                        </Form.Group>

                        <Form.Group>
                            <SelectInput
                                name="health"
                                id="health"
                                value={props.formState.health}
                                onChange={(e) => handleValueChange('health', e.target.value)}
                                label="Current Health Status"
                                inputRef={register}
                                selectOptions={HealthClasses()}
                                errors={errors && errors.health}
                            />
                        </Form.Group>
                        </div>}
                        {
                            !props.isTerm && isLedger &&
                            <Form.Group>
                            <TextInput
                                name="secondaryInsuredName"
                                id="secondaryInsuredName"
                                label="Secondary Insured Name"
                                value={props.formState.secondaryInsuredName}
                                onChange={e => handleValueChange('secondaryInsuredName', e.target.value)}
                                errors={errors && errors.secondaryInsuredName}
                                inputRef={register}
                            />
                        </Form.Group>

                        }
                    </Col>
                </Row>
                <BackNextButton onBack={props.onBack} />
            </form>
        </Container >
    )
}

PrimaryInsuredInfo.propTypes = {
    formState: PropTypes.object.isRequired,
    onNext: PropTypes.func.isRequired,
    onBack: PropTypes.func.isRequired,
    onFieldChange: PropTypes.func.isRequired,
    ageSpecs: PropTypes.object.isRequired
};

PrimaryInsuredInfo.ValidationSchema = (ageSpecs,isTerm,isLedger) => {
    return object().shape({
        clientFirstName: customValidators.string()
        .isValidNameLimitedSpecialChar("Client's First Name is required.", true, false),
        clientLastName: customValidators.string()
            .isValidNameLimitedSpecialChar("Client's Last Name is required.", true, false),
        birthdate: customValidators.string().isValidateAgeAndDifferenceFromBirthdate('Invalid Date.', ageSpecs.min, ageSpecs.max,
            `This product is only available from age ${ageSpecs.min} to ${ageSpecs.max}.`),
        state:isTerm || isLedger? string().required('State is required.'):string().notRequired(),
        gender:isTerm || isLedger? string().required('Gender is required.'):string().notRequired(),
        maritalStatus:isTerm || isLedger? string().notRequired():string().notRequired(),
        health:isTerm || isLedger? string().required('Health Class is required.'):string().notRequired(),
        email: isTerm || isLedger ?string().email('Email address must be valid').required('Email address is required.'):string().notRequired(),
        secondaryInsuredName : customValidators.string()
        .isValidNameLimitedSpecialChar("", false, false),
    });
};

PrimaryInsuredInfo.DefaultFormState = (prefill = false) => {
    return {
        clientFirstName: prefill ? 'R' : '',
        clientLastName: prefill ? 'S' : '',
        birthdate: prefill ? '01/01/1980' : '',
        state: prefill ? 'CT' : '',
        gender: prefill ? 'M' : '',
        maritalStatus: prefill ? 'Single' : '',
        email: prefill ? 'user@address.com' : '',
        health: prefill ? 'PP' : '',
        secondaryInsuredName : prefill ? 'ABC':''
    }
};




// WEBPACK FOOTER //
// ./src/components/PolicyReview/PrimaryInsuredInfo.js